'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (attributes) {
  var htmlAttrs = '';

  for (var k in attributes) {
    var v = attributes[k];

    if (BOOLEAN_ATTRIBUTES[k]) {
      v = v ? k : null;
    }

    if (v == null) {
      continue;
    }

    htmlAttrs += ' ' + (0, _htmlEscape2.default)(k) + '="' + (0, _htmlEscape2.default)(v.toString()) + '"';
  }

  return htmlAttrs;
};

var _htmlEscape = require('./htmlEscape');

var _htmlEscape2 = _interopRequireDefault(_htmlEscape);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BOOLEAN_ATTRIBUTES = {
  disabled: true,
  readonly: true,
  multiple: true,
  checked: true
}; // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];